module.exports = __webpack_public_path__ + "static/img/home.5c9f925.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home.png
// module id = KSZv
// module chunks = 2